import { getVariantAlphabets } from "@/api/sale-api";
import { useEffect, useState } from "react";

export function useSaleVariants() {
    const [alphabets, setAlphabets] = useState<string[]>([]);
    const [isLoadingAlphabets, setIsLoadingAlphabets] = useState(false);
    const loadVariantAlphabets = async () => {
        setIsLoadingAlphabets(true);
        const alphabets = await getVariantAlphabets();
        setAlphabets(alphabets.data);
        setIsLoadingAlphabets(false);
    };
    useEffect(() => {
        loadVariantAlphabets();
    }, []);
    return { alphabets, isLoadingAlphabets };
}